import "./global.css"
import Router from "./routes/router";

const App = () => <Router />;

export default App;
